import { render, staticRenderFns } from "./HeaderCart.vue?vue&type=template&id=facb6c50"
import script from "./HeaderCart.vue?vue&type=script&lang=ts"
export * from "./HeaderCart.vue?vue&type=script&lang=ts"
import style0 from "./HeaderCart.vue?vue&type=style&index=0&id=facb6c50&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports